import { useCacheLocal } from "@/hooks/useCacheLocal";
import { createContext, ReactNode, useContext, useState } from "react";

type TInformationFilterCache = {
  page?: number | null;
};

type InformationFilterCacheContextType = {
  informationFilterCache: TInformationFilterCache;
  setInformationFilterCache: (newFilter: TInformationFilterCache) => void;
};

const InformationFilterCacheContext = createContext<InformationFilterCacheContextType | undefined>(undefined);

export const InformationFilterCacheProvider = ({ children }: { children: ReactNode }) => {
  const { getJSON, setJSON } = useCacheLocal("information-filter");

  const [informationFilterCache, setInformationFilter] = useState<TInformationFilterCache>({
    ...getJSON(),
  });

  const setInformationFilterCache = (newFilter: TInformationFilterCache) => {
    setJSON(newFilter);
    setInformationFilter(newFilter);
  };

  return (
    <InformationFilterCacheContext.Provider value={{ informationFilterCache, setInformationFilterCache }}>
      {children}
    </InformationFilterCacheContext.Provider>
  );
};

export const useInformationFilterCache = (): InformationFilterCacheContextType => {
  const context = useContext(InformationFilterCacheContext);
  if (!context) {
    throw new Error("useInformationFilterCache must be used within InformationFilterCacheProvider");
  }
  return context;
};
